import Loader from 'components/atoms/loader';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import ReCAPTCHA from 'react-google-recaptcha';
import EmptyResult from 'components/atoms/empty_result';
import { FollowupData } from 'store/modules/followup_store/types';
import { FollowupTypes } from 'store/modules/bidding_store/types';
import TotalEntriesLabel from 'components/atoms/total_entries_label';
import BiddingFollowupItem from 'components/molecules/bidding_followup_item';

interface BiddingFollowupListProps {
  loaded: boolean;
  followups: Array<FollowupTypes | FollowupData>;
}

const BiddingFollowupList = (props: BiddingFollowupListProps) => {
  const { followups, loaded } = props;

  // const { RECAPTCHA_SITE_KEY } = process.env;

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const [showCaptcha, setShowCaptcha] = useState<boolean>(false);
  const [token, setToken] = useState<string | null>(null);

  const recaptchaRef = React.createRef<ReCAPTCHA>();

  return (
    <div className="row followup-list">
      {profile.enable_captcha && showCaptcha === true && token === null && (
        <div className="w-100 d-flex justify-content-center mt-5">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6Lcex2sdAAAAAKMks7alzUBCyRFy88kgqM07DcwW"
            onChange={(recaptchaToken: React.SetStateAction<string | null>) => {
              setShowCaptcha(false);
              setToken(recaptchaToken);
            }}
            hl="pt-BR"
          />
        </div>
      )}
      {profile.enable_captcha && showCaptcha === false && token === null && (
        <div className="d-flex justify-content-center mt-5">
          <button
            type="button"
            className="btn btn-success btn-sm mr-1"
            onClick={() => {
              setShowCaptcha(true);
            }}
            disabled={showCaptcha}
          >
            Ver Acompanhamentos
          </button>
        </div>
      )}
      {!loaded && (!profile.enable_captcha || token !== null) && <Loader />}
      {loaded && (!profile.enable_captcha || token !== null) && followups?.length > 0 && (
        <div className="row">
          <div className="col-11 col-lg-11 mx-auto border-top">
            <div className="my-3 d-flex align-items-center">
              <TotalEntriesLabel itemLabel="acompanhamentos" totalEntries={followups?.length} />
            </div>
            {followups?.map((followup) => (
              <BiddingFollowupItem followup={followup} />
            ))}
          </div>
        </div>
      )}
      {loaded && (!profile.enable_captcha || token !== null) && followups?.length === 0 && (
        <EmptyResult
          title="Desculpe!"
          description="Não temos licitações que correspondam a esses filtros."
        />
      )}
    </div>
  );
};

export default BiddingFollowupList;
